// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.banner {
  border-radius: var(--radius-sm);
  padding: var(--space-4);
  margin: 0;
  width: 100%;
  border: 1px solid transparent;
}

.banner-content {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.banner-icon {
  flex-shrink: 0;
  margin-top: 2px;
}

.banner-text {
  flex: 1;
  min-width: 0;
}

.banner-title {
  margin-bottom: 0;
  display: block;
}

.banner-message {
  margin: 0;
  display: block;
}

/* Variant-specific background colors */
.banner-caution {
  background-color: var(--color-pastelle-yellow);
}

.banner-warning {
  background-color: var(--color-pastelle-red);
}

.banner-info {
  background-color: var(--color-pastelle-gray);
}

.banner-tip {
  background-color: var(--color-pastelle-blue);
}

/* Responsive design */
@media (max-width: 768px) {
  .banner {
    padding: 12px;
    margin: 12px 0;
  }
  
  .banner-content {
    gap: 8px;
  }
  
  .banner-icon {
    margin-top: 1px;
  }
}

/* Expandable-info variant */
.banner-expandable-info {
  background-color: var(--color-pastelle-gray);
}

.banner-expandable-text {
  width: 100%;
}

.banner-expandable-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.banner-expandable-summary {
  flex: 1;
  min-width: 0;
}

.banner-expandable-summary-line {
  margin-top: 2px;
  display: block;
}

.banner-expandable-toggle {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  margin: -4px -4px 0 0;
  background: none;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  color: inherit;
  transition: background-color 0.2s ease;
}

.banner-expandable-toggle:hover {
  background-color: rgba(255, 255, 255, 0.08);
}

.banner-expandable-toggle:focus-visible {
  outline: 2px solid var(--color-primary-green);
  outline-offset: 2px;
}

.banner-expandable-content {
  overflow: hidden;
  max-height: 0;
  transition: max-height 0.25s ease-out;
}

.banner-expandable-content-open {
  max-height: 80vh;
  overflow-y: auto;
}

.banner-expandable-content-inner {
  padding-top: 12px;
  padding-bottom: 4px;
}

@media (max-width: 768px) {
  .banner-expandable-toggle {
    width: 28px;
    height: 28px;
    margin: -2px -2px 0 0;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/Banner/Banner.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE,8CAA8C;AAChD;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,4BAA4B;AAC5B;EACE,4CAA4C;AAC9C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,qBAAqB;EACvB;AACF","sourcesContent":[".banner {\n  border-radius: var(--radius-sm);\n  padding: var(--space-4);\n  margin: 0;\n  width: 100%;\n  border: 1px solid transparent;\n}\n\n.banner-content {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.banner-icon {\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.banner-text {\n  flex: 1;\n  min-width: 0;\n}\n\n.banner-title {\n  margin-bottom: 0;\n  display: block;\n}\n\n.banner-message {\n  margin: 0;\n  display: block;\n}\n\n/* Variant-specific background colors */\n.banner-caution {\n  background-color: var(--color-pastelle-yellow);\n}\n\n.banner-warning {\n  background-color: var(--color-pastelle-red);\n}\n\n.banner-info {\n  background-color: var(--color-pastelle-gray);\n}\n\n.banner-tip {\n  background-color: var(--color-pastelle-blue);\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .banner {\n    padding: 12px;\n    margin: 12px 0;\n  }\n  \n  .banner-content {\n    gap: 8px;\n  }\n  \n  .banner-icon {\n    margin-top: 1px;\n  }\n}\n\n/* Expandable-info variant */\n.banner-expandable-info {\n  background-color: var(--color-pastelle-gray);\n}\n\n.banner-expandable-text {\n  width: 100%;\n}\n\n.banner-expandable-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.banner-expandable-summary {\n  flex: 1;\n  min-width: 0;\n}\n\n.banner-expandable-summary-line {\n  margin-top: 2px;\n  display: block;\n}\n\n.banner-expandable-toggle {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  margin: -4px -4px 0 0;\n  background: none;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  color: inherit;\n  transition: background-color 0.2s ease;\n}\n\n.banner-expandable-toggle:hover {\n  background-color: rgba(255, 255, 255, 0.08);\n}\n\n.banner-expandable-toggle:focus-visible {\n  outline: 2px solid var(--color-primary-green);\n  outline-offset: 2px;\n}\n\n.banner-expandable-content {\n  overflow: hidden;\n  max-height: 0;\n  transition: max-height 0.25s ease-out;\n}\n\n.banner-expandable-content-open {\n  max-height: 80vh;\n  overflow-y: auto;\n}\n\n.banner-expandable-content-inner {\n  padding-top: 12px;\n  padding-bottom: 4px;\n}\n\n@media (max-width: 768px) {\n  .banner-expandable-toggle {\n    width: 28px;\n    height: 28px;\n    margin: -2px -2px 0 0;\n  }\n} "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
